export default "__VITE_ASSET__HxKxXyg6__"